import React from 'react'

const TechnicalGuides = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/technicalGuides',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <g
        stroke={primaryColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.2'>
        <path
          d='M3.5 6l4.667-5h7.4c.484 0 .933.52.933 1v16c0 .48-.45 1-.933 1H4.433c-.484 0-.933-.52-.933-1V6z' />
        <path
          d='M3.5 6h5V1z' />
      </g>
      <path
        d='M12.251 7.506c.155.008.311.033.462.073l-1.046 1.049a1.2 1.2 0 0 0 0 1.708 1.202 1.202 0 0 0 1.71 0l1.043-1.047a2.434 2.434 0 0 1-.619 2.326 2.353 2.353 0 0 1-1.676.688c-.236 0-.471-.034-.7-.1l-.205-.06-.151.152-3.926 3.923a.956.956 0 0 1-.68.282.966.966 0 0 1-.68-1.646l3.925-3.924.151-.151-.06-.206a2.408 2.408 0 0 1 .589-2.374 2.38 2.38 0 0 1 1.863-.693z'
        fill={primaryColor} />
    </g>
  </svg>
)

export default TechnicalGuides
